import { render, staticRenderFns } from "./ManageELibrary.vue?vue&type=template&id=4b8455c3"
import script from "./ManageELibrary.vue?vue&type=script&lang=js"
export * from "./ManageELibrary.vue?vue&type=script&lang=js"
import style0 from "./ManageELibrary.vue?vue&type=style&index=0&id=4b8455c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports